import { InputSelect, Paragraph } from '@welbe/web-design-system';
import { useContext } from 'react';
import { statusInfo } from '../../DrawerEmployees.constants';
import { DrawerEmployeesContext } from '../../DrawerEmployees.context';
import { renderDate } from '../../DrawerEmployees.functions';
import { ItemWrapper } from '../../DrawerEmployees.styles';
import { DrawerEmployeesContextProps } from '../../DrawerEmployees.types';

export const Lecture = (): JSX.Element => {
	const { selectedFormData, handleChangeData, options } =
		useContext<DrawerEmployeesContextProps>(DrawerEmployeesContext);

	return (
		<ItemWrapper>
			{selectedFormData?.map((item) => (
				<ItemWrapper key={item.actionId} gap="5px">
					<Paragraph fontWeight="700">{item.name}</Paragraph>
					<Paragraph fontWeight="500">{item?.description}</Paragraph>
					<Paragraph>{renderDate(item?.dateStart, item?.dateEnd)}</Paragraph>
					<InputSelect
						options={options}
						disabled={item?.canEdit === false}
						onChange={(value) =>
							handleChangeData(item.actionId, 'chats', value.id)
						}
						value={options.find((option) => option.id === item.status)}
						statusDot
						statusInfo={statusInfo}
					/>
				</ItemWrapper>
			))}
		</ItemWrapper>
	);
};
